import { render } from "./User.vue?vue&type=template&id=0ddfc0e6&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"

import "./User.vue?vue&type=style&index=0&id=0ddfc0e6&scoped=true&lang=css"
import "./User.vue?vue&type=style&index=1&id=0ddfc0e6&lang=css"

import exportComponent from "/Users/iammaham/Documents/JS/estate_soluce/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ddfc0e6"]])

export default __exports__